module.exports = __webpack_public_path__ + "static/media/galaxycat.26a6a121.png";